import React, { createContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

export const GlobalContext = createContext();

const GlobalContextProvider = ({ children }) => {
    const [apiGlobal, setApiGlobal] = useState('https://navrang.mvd-tech.io/API');
    const [apiGlobalforlogin, setGlobalforlogin] = useState('https://agentbw.mvd-tech.io/API'); // Development
   
    // const [apiGlobal, setApiGlobal] = useState('https://admin.bitevize.com/API');
    // const [apiGlobalforlogin, setGlobalforlogin] = useState('https://agent.bitevize.com/API'); // Production

  const value = useMemo(() => ({
    apiGlobal,
    apiGlobalforlogin,
  }), [apiGlobal, apiGlobalforlogin]);

  return (
    <GlobalContext.Provider value={value}>
      {children}
    </GlobalContext.Provider>
  );
};

GlobalContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GlobalContextProvider;
